import { render } from "./CheckboxInput.vue?vue&type=template&id=1bdc2b94&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=1bdc2b94&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdc2b94"]])

export default __exports__